import { render, staticRenderFns } from "./LicenceOverview.vue?vue&type=template&id=16a7c16b"
import script from "./LicenceOverview.vue?vue&type=script&lang=js"
export * from "./LicenceOverview.vue?vue&type=script&lang=js"
import style0 from "./LicenceOverview.vue?vue&type=style&index=0&id=16a7c16b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports